import { useState } from 'react';
import { MagnifyingGlassPlusIcon } from '@heroicons/react/24/outline';
import { FullScreenImage } from '@geerd-nx/ui';

export function ImagePreview({ src }: { src: string }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        title="Preview Image"
        onClick={() => setOpen(true)}
        className="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
      >
        <MagnifyingGlassPlusIcon className="h-4 w-4" aria-hidden="true" />
      </button>
      <FullScreenImage
        src={src
          .split('/')
          .splice(0, src.split('/').length - 1)
          .concat('qhd')
          .join('/')}
        open={open}
        setOpen={setOpen}
      />{' '}
    </>
  );
}
